import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-16" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "max-w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ArrowPathIcon = _resolveComponent("ArrowPathIcon")!
  const _component_ExamplesCollection = _resolveComponent("ExamplesCollection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, [
      (_ctx.category)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: _ctx.docsRoute(_ctx.DocsRoute.EXAMPLES)
          }, {
            default: _withCtx(() => [
              _createTextVNode("Examples")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, "Examples")),
      (_ctx.category)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " / " + _toDisplayString(_ctx.category), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ArrowPathIcon, {
          key: 0,
          class: "animate-spin inline pointer-events-none absolute top-3.5 right-4 h-5 w-5 text-gray-400"
        }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.displayedCategories, (category, i) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.displayedCategories.length > 1)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: _ctx.docsExampleCategoryPath(category),
                  class: "hover:cursor-pointer opacity-90 hover:opacity-100"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(category), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
              : _createCommentVNode("v-if", true),
            (_ctx.exampleNamesByCategory[i].length)
              ? (_openBlock(), _createBlock(_component_ExamplesCollection, {
                  key: i,
                  exampleNames: _ctx.exampleNamesByCategory[i],
                  exampleDatas: _ctx.exampleDatasByCategory[i]
                }, null, 8 /* PROPS */, ["exampleNames", "exampleDatas"]))
              : _createCommentVNode("v-if", true)
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
  ], 64 /* STABLE_FRAGMENT */))
}